@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ComponentOverflow {
  @extend %font-family-primary;

  display: flex;
  align-items: center;

  &.Wrap {
    flex-wrap: wrap;
  }

  .OverflowPlaceholder {
    cursor: default;
  }

  .Hyperlink {
    background: $theme-color-background;
    border-radius: 4px;
    padding: 2px 6px;

    &:hover {
      background: $theme-color-dark-secondary-button-hover;
    }

    &:active {
      background: $theme-color-checkbox-disabled-checked-background;
    }
  }

  &.NoAlign {
    align-items: normal;
  }
}

.OverflowTooltips {
  display: grid;
  grid-template-rows: auto 1fr;
  row-gap: 16px;

  .ChildrenList {
    display: flex;
    max-width: 400px;
    flex-wrap: wrap;
    align-items: center;
  }
}

.WrappedChildren {
  width: max-content;
}
